import { render, staticRenderFns } from "./Kilimanjaro.vue?vue&type=template&id=21122f08&scoped=true&"
import script from "./Kilimanjaro.vue?vue&type=script&lang=js&"
export * from "./Kilimanjaro.vue?vue&type=script&lang=js&"
import style0 from "./Kilimanjaro.vue?vue&type=style&index=0&id=21122f08&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21122f08",
  null
  
)

export default component.exports